/* Tropical Corner — home: solo progressive enhancement.
   Senza JS tutto resta visibile, navigabile e indicizzabile. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero: slider vero (autoplay, frecce, dots, swipe) ---------- */
  function initHeroSlider(root) {
    var slider = root.querySelector('.tc-hero-slider');
    if (!slider) return;
    var track = slider.querySelector('.tc-hero-track');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.tc-hero-slide'));
    if (!track || slides.length < 2) return;

    var dotsWrap = slider.querySelector('.tc-hero-dots');
    var prevBtn = slider.querySelector('.tc-hero-nav--prev');
    var nextBtn = slider.querySelector('.tc-hero-nav--next');
    var index = 0;
    var total = slides.length;
    var isHovering = false;
    var raf = null;
    var progress = 0;
    var lastTime = 0;
    var DURATION = 8500;

    var dots = slides.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tc-hero-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', (i + 1) + ' / ' + total);
      dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      dot.addEventListener('click', function () { goTo(i); reset(); });
      if (dotsWrap) dotsWrap.appendChild(dot);
      return dot;
    });

    function update() {
      track.style.transform = reduceMotion ? 'none' : 'translateX(-' + (index * 100) + '%)';
      if (reduceMotion) {
        slides.forEach(function (s, i) { s.style.display = i === index ? '' : 'none'; });
      }
      slides.forEach(function (s, i) {
        var active = i === index;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.inert = !active;
      });
      dots.forEach(function (d, i) {
        var active = i === index;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function goTo(i) { index = (i + total) % total; update(); }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); reset(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); reset(); });

    function loop(t) {
      if (!lastTime) lastTime = t;
      var dt = t - lastTime;
      lastTime = t;
      if (!isHovering && !document.hidden) {
        progress += dt;
        if (progress >= DURATION) { progress = 0; next(); }
      }
      raf = requestAnimationFrame(loop);
    }
    function start() { if (reduceMotion) return; lastTime = 0; raf = requestAnimationFrame(loop); }
    function stop() { if (raf) cancelAnimationFrame(raf); }
    function reset() { progress = 0; }

    slider.addEventListener('mouseenter', function () { isHovering = true; });
    slider.addEventListener('mouseleave', function () { isHovering = false; });
    slider.addEventListener('focusin', function () { isHovering = true; });
    slider.addEventListener('focusout', function () { isHovering = false; });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Swipe
    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches.length) startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 45) { diff < 0 ? next() : prev(); reset(); }
    }, { passive: true });

    // Tastiera
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); reset(); }
      else if (e.key === 'ArrowRight') { next(); reset(); }
    });

    update();
    start();
  }

  /* ---------- Frecce dei rail (lo scroll resta nativo) ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-tc-arrows]').forEach(function (group) {
      var rail = document.getElementById(group.getAttribute('data-tc-arrows'));
      if (!rail) return;
      var prev = group.querySelector('[data-dir="-1"]');
      var next = group.querySelector('[data-dir="1"]');
      var ticking = false;

      function sync() {
        ticking = false;
        var max = rail.scrollWidth - rail.clientWidth - 4;
        prev.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft >= max;
        group.hidden = max <= 0;
      }

      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dir]');
        if (!btn) return;
        rail.scrollBy({ left: Number(btn.dataset.dir) * rail.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      rail.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(sync); }
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
      sync();
    });
  }

  /* ---------- Mystery Box: flip accessibile ---------- */
  function initVault(root) {
    root.querySelectorAll('[data-tc-vault]').forEach(function (card) {
      var front = card.querySelector('.tc-vault__front');
      var back = card.querySelector('.tc-vault__back');
      if (!front || !back) return;
      back.inert = true;

      front.addEventListener('click', function () {
        if (card.classList.contains('is-open')) return;
        var open = function () {
          card.classList.remove('is-shaking');
          card.classList.add('is-open');
          front.setAttribute('aria-expanded', 'true');
          front.inert = true;
          back.inert = false;
          var link = back.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        };
        if (reduceMotion) return open();
        card.classList.add('is-shaking');
        setTimeout(open, 360);
      });
    });
  }

  /* ---------- Recensioni: "Leggi tutto" solo se il testo è troncato ---------- */
  function initReviews(root) {
    var boxes = root.querySelectorAll('[data-tc-clamp]');
    if (!boxes.length) return;

    function measure() {
      boxes.forEach(function (box) {
        var btn = box.nextElementSibling;
        if (!btn || box.classList.contains('is-open')) return;
        var p = box.querySelector('p');
        btn.hidden = !(p && p.scrollHeight > p.clientHeight + 2);
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.tc-review__more');
      if (!btn) return;
      var box = btn.previousElementSibling;
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });

    // Le card sono in sezioni con content-visibility: misuriamo quando diventano visibili
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { measure(); io.disconnect(); }
      });
      io.observe(boxes[0].closest('section'));
    } else {
      measure();
    }
    window.addEventListener('resize', measure, { passive: true });
  }

  /* ---------- Newsletter: invio senza ricaricare, fallback nativo per captcha ---------- */
  function initNewsletter(root) {
    var form = root.querySelector('[data-tc-news]');
    if (!form || !window.fetch) return;
    var status = form.querySelector('.tc-news__status');
    var email = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var label = btn.textContent;

    function say(msg, isError) {
      status.textContent = msg;
      status.classList.toggle('is-error', !!isError);
    }

    form.addEventListener('submit', function (e) {
      var value = (email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        e.preventDefault();
        say(form.dataset.errEmail, true);
        email.focus();
        return;
      }
      e.preventDefault();
      form.setAttribute('aria-busy', 'true');
      btn.textContent = form.dataset.sending;

      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (res) {
          if (/\/challenge/.test(res.url)) {
            // Shopify richiede hCaptcha: serve un submit top-level
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
          if (/customer_posted=true/.test(res.url)) {
            form.reset();
            say(form.dataset.ok, false);
            return;
          }
          // Nessun redirect di successo: leggiamo il messaggio che la section stessa ha renderizzato
          return res.text().then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var rendered = doc.querySelector('[data-tc-news] .tc-news__status');
            var msg = rendered ? rendered.textContent.trim() : '';
            say(msg || form.dataset.err, msg !== form.dataset.ok);
          });
        })
        .catch(function () { HTMLFormElement.prototype.submit.call(form); })
        .finally(function () {
          form.removeAttribute('aria-busy');
          btn.textContent = label;
        });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.tc-home').forEach(function (root) {
      initHeroSlider(root);
      initRails(root);
      initVault(root);
      initReviews(root);
      initNewsletter(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: re-inizializza solo la section appena ricaricata
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
